// ================================
// AUTH CONTEXT
// ================================
import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser]     = useState(null);
  const [role, setRole]     = useState(null); // 'customer' | 'admin' | 'driver'
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Restore session from localStorage on load
    const token = localStorage.getItem('ww_token');
    const savedUser = localStorage.getItem('ww_user');
    const savedRole = localStorage.getItem('ww_role');

    if (token && savedUser && savedRole) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      setUser(JSON.parse(savedUser));
      setRole(savedRole);
    }
    setLoading(false);
  }, []);

  async function loginCustomer(mid, pin) {
    const res = await axios.post('/api/auth/customer/login', { mid, pin });
    saveSession(res.data.token, res.data.member, 'customer');
    return res.data.member;
  }

  async function activateCustomer(mid, pin) {
    const res = await axios.post('/api/auth/customer/activate', { mid, pin });
    saveSession(res.data.token, res.data.member, 'customer');
    return res.data.member;
  }

  async function loginAdmin(password) {
    const res = await axios.post('/api/auth/admin/login', { password });
    saveSession(res.data.token, { name: 'Admin' }, 'admin');
  }

  async function loginDriver(name, pin) {
    const res = await axios.post('/api/auth/driver/login', { name, pin });
    saveSession(res.data.token, res.data.driver, 'driver');
    return res.data.driver;
  }

  async function activateDriver(name, pin) {
    const res = await axios.post('/api/auth/driver/activate', { name, pin });
    saveSession(res.data.token, res.data.driver, 'driver');
    return res.data.driver;
  }

  async function loginStaff(username, pin) {
    const res = await axios.post('/api/auth/staff/login', { username, pin });
    saveSession(res.data.token, res.data.staff, 'staff');
    return res.data.staff;
  }

  async function activateStaff(username, phone, pin) {
    const res = await axios.post('/api/auth/staff/activate', { username, phone, pin });
    saveSession(res.data.token, res.data.staff, 'staff');
    return res.data.staff;
  }

  function saveSession(token, userData, userRole) {
    localStorage.setItem('ww_token', token);
    localStorage.setItem('ww_user', JSON.stringify(userData));
    localStorage.setItem('ww_role', userRole);
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    setUser(userData);
    setRole(userRole);
  }

  function logout() {
    localStorage.removeItem('ww_token');
    localStorage.removeItem('ww_user');
    localStorage.removeItem('ww_role');
    delete axios.defaults.headers.common['Authorization'];
    setUser(null);
    setRole(null);
  }

  return (
    <AuthContext.Provider value={{ user, role, loading, loginCustomer, activateCustomer, loginAdmin, loginDriver, activateDriver, loginStaff, activateStaff, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
